import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UniversityType } from "../../../types/University";

const initialState: UniversityType = {
    id: '',
    description: '',
    province: "",
    
};

export const universitySlice = createSlice({
    name: "universityForm",
    initialState,
    reducers: {
        setUniversityData: (state, action: PayloadAction<UniversityType>) => {
            return { ...state, ...action.payload };
        },
        resetUniversityData: () => {
            return initialState;
        }
    }
});

export const { setUniversityData, resetUniversityData } = universitySlice.actions;
export default universitySlice.reducer;
